import { render } from "./AllinvestPage.vue?vue&type=template&id=00c4c75a&scoped=true"
import script from "./AllinvestPage.vue?vue&type=script&lang=js"
export * from "./AllinvestPage.vue?vue&type=script&lang=js"

import "./AllinvestPage.vue?vue&type=style&index=0&id=00c4c75a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c4c75a"]])

export default __exports__